import Footer from "../components/common/footer";
import Header from "../components/common/header";
import { Helmet } from "react-helmet";
import Hero from "../components/documents1/hero";
import Content from "../components/documents1/content";

function Document1() {
  return (
    <>
      <Helmet>
        <title>Regulamin Serwisu | Drzewus</title>
        <meta name="title" content="Regulamin Serwisu | Drzewus" />
        <meta
          name="description"
          content="Świadczymy kompleksowe usługi ogrodnicze, w tym projektowanie ogrodów, pielęgnację zieleni, wycinkę drzew i krzewów oraz nawadnianie."
          key="desc"
        />
        <meta property="og:title" content="Regulamin Serwisu | Drzewus" />
        <meta
          property="og:description"
          content="Świadczymy kompleksowe usługi ogrodnicze, w tym projektowanie ogrodów, pielęgnację zieleni, wycinkę drzew i krzewów oraz nawadnianie."
        />
        <meta property="og:image" content="" />
      </Helmet>
      <Header />
      <main className="relative z-40">
        <Hero />
        <Content />
      </main>
      <Footer />
    </>
  );
}
export default Document1;
